const CallToAction = () => {
  const doesOverlap = (a, b) => {
    const rectA = a.getBoundingClientRect();
    const rectB = b.getBoundingClientRect();

    return !(
      rectA.right < rectB.left ||
      rectA.left > rectB.right ||
      rectA.bottom < rectB.top ||
      rectA.top > rectB.bottom
    );
  };

  const installHeights = () => {
    const callToActionBlocks = [...document.querySelectorAll(".call-to-action")];

    callToActionBlocks.forEach((block) => {
      const buttons = [...block.querySelectorAll(".btn")];
      const isCapabilityList = block.closest('.capability-list__btns-container');
      const container = isCapabilityList;
      const switcher = container?.querySelector('.capability-list__table-switcher');

      // Сброс состояния
      buttons.forEach(btn => (btn.style.width = 'auto'));
      block.style.paddingRight = '';
      container?.classList.remove('is-overlapping');
      block.classList.remove('is-overlapping');

      // ---------------------------
      // Специальная логика для capability-list
      // ---------------------------
      if (isCapabilityList) {
        console.log('[capability-list] — found');

        if (buttons.length > 1) {
          const maxWidth = Math.max(...buttons.map(btn => btn.offsetWidth));
          buttons.forEach(btn => {
            btn.style.width = `${maxWidth}px`;
          });

          console.log(`[capability-list] buttons set to equal width: ${maxWidth}px`);

          // Проверка перекрытия после выравнивания
          let isOverlap = false;
          if (window.innerWidth >= 1200 && switcher) {
            for (const btn of buttons) {
              if (doesOverlap(btn, switcher)) {
                isOverlap = true;
                break;
              }
            }
          }

          if (isOverlap) {
            console.log('[capability-list] overlap after equal width — reverting to auto width');

            // Сброс на авто
            buttons.forEach(btn => (btn.style.width = 'auto'));

            // Проверка ещё раз
            let stillOverlap = false;
            if (window.innerWidth >= 1200 && switcher) {
              for (const btn of buttons) {
                if (doesOverlap(btn, switcher)) {
                  stillOverlap = true;
                  break;
                }
              }
            }

            if (stillOverlap) {
              console.log('[capability-list] still overlapping — applying padding-right');
              block.style.paddingRight = `${switcher.offsetWidth + 16}px`;
              container.classList.add('is-overlapping');
              block.classList.add('is-overlapping');
            }
          } else {
            console.log('[capability-list] no overlap — equal width kept');
          }
        }

        return;
      }

      // -------------------------
      // Общая логика (как раньше)
      // -------------------------
      if (buttons.length > 0) {
        console.log('[standard block] processing');
        const maxWidth = Math.max(...buttons.map(button => {
          const style = window.getComputedStyle(button);
          const paddingLeft = parseFloat(style.paddingLeft);
          const paddingRight = parseFloat(style.paddingRight);
          return button.getBoundingClientRect().width + paddingLeft + paddingRight;
        }));

        buttons.forEach(button => {
          button.style.width = `${maxWidth}px`;
        });

        console.log(`[standard block] buttons set to equal width: ${maxWidth}px`);
      }
    });
  };

  window.addEventListener('resize', installHeights);
  window.addEventListener('load', installHeights);
  installHeights();
};

export default CallToAction;
